(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accelerator-steps"] && !window.DesignMode) return;
  try {
    

const slider = document.querySelector('.items-slider');
let isDown = false;
let startX;
let scrollLeft;

slider.addEventListener('mousedown', (e) => {
  isDown = true;
  slider.classList.add('active');
  startX = e.pageX - slider.offsetLeft;
  scrollLeft = slider.scrollLeft;
});
slider.addEventListener('mouseleave', () => {
  isDown = false;
  slider.classList.remove('active');
});
slider.addEventListener('mouseup', () => {
  isDown = false;
  slider.classList.remove('active');
});
slider.addEventListener('mousemove', (e) => {
  if(!isDown) return;
  e.preventDefault();
  const x = e.pageX - slider.offsetLeft;
  const walk = (x - startX) * 1.5; //scroll-fast
  slider.scrollLeft = scrollLeft - walk;
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-page-content-box"] && !window.DesignMode) return;
  try {
    
  var $this = $('.content-box.read-more');
  if ($this.find('.box').length > 2) { 
      $('.content-box.read-more').append('<div class="landing moreless-btn"><a href="javascript:;" class="readMore"></a></div>');
  }
  $('.content-box.read-more .box').slice(0,6).addClass('shown');
  $('.content-box.read-more .box').not('.shown').hide();
  $('.content-box.read-more .readMore').on('click',function(){
      $('.content-box.read-more .box').not('.shown').toggle(0);
      $(this).toggleClass('readLess');
  });

   $(document).ready(function () {
     var ingredientsLink = $('.ingredients');
   $(window).scroll(function () {
    var scrollTop = $(this).scrollTop();
    var href = ingredientsLink.attr('href');

    if (href && href.startsWith('#')) {
      var content = $(href);

      if (scrollTop > content.offset().top) {
        ingredientsLink.hide();
      } else {
        ingredientsLink.show();
      }

      history.replaceState({}, document.title, window.location.pathname + window.location.search);

    }
   });
    // Open Popup
    $('.openBtn').on('click', function () {
      $('.popup')
        .css("display", "flex")
        .hide()
        .fadeIn(300);
    });

    // Close Popup
    $('.closeBtn').on('click', function () {
      $('.popup').fadeOut(300);
    });

    // Close Popup when Click outside
    $('.popup').on('click', function () {
      $('.popup').fadeOut(300);
    }).children().click(function () {
      return false;
    });

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-page-faq"] && !window.DesignMode) return;
  try {
    

$(function () {
  $(".faqs .ans").css("display", "none");
  $(".faqs .qus").click(function () {
    $(".open").not(this).removeClass("open").next().slideUp(300);
    $(this).toggleClass("open").next().slideToggle(300);
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-product-ingredients"] && !window.DesignMode) return;
  try {
    

jQuery(document).ready(function(){

  var $this = $('.ingr-box.load-more');
  if ($this.find('.ingr-item').length > 2) {
      $('.ingr-box.load-more').append('<div class="moreless-btn"><a href="javascript:;" class="showMore"></a></div>');
  }
  $('.ingr-box.load-more .ingr-item').slice(0,8).addClass('shown');
  $('.ingr-box.load-more .ingr-item').not('.shown').hide();
  $('.ingr-box.load-more .showMore').on('click',function(){
      $('.ingr-box.load-more .ingr-item').not('.shown').toggle(0);
      $(this).toggleClass('showLess');
  });
  
  $(".tab-slider").slick({
    autoplay:false,
    infinite:true,
    slidesToShow:1,
    slidesToScroll:1,
    dots:true,
    arrows:false,
  });

  $(".mob-slider").slick({
    autoplay:false,
    infinite:true,
    slidesToShow:1,
    slidesToScroll:1,
    dots:true, 
    arrows:false,
  });

});  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-seedboost-features"] && !window.DesignMode) return;
  try {
    

$(document).ready(function() {
$('.feature-accordion .item:nth-child(1) h5').addClass('active');
$('.feature-accordion .item:nth-child(1) p').slideDown();
$('.feature-accordion .item h5').on('click', function() {
    if($(this).hasClass('active')) {
      $(this).siblings('.feature-accordion .item p').slideUp();
      $(this).removeClass('active');
    }
    else {
      $('.feature-accordion .item p').slideUp();
      $('.feature-accordion .item h5').removeClass('active');
      $(this).siblings('.feature-accordion .item p').slideToggle();
      $(this).toggleClass('active');
    }
});     
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["science-formulation"] && !window.DesignMode) return;
  try {
    

  $(document).ready(function() {
   $('.formula-list:nth-child(1) .formula-list-wrapper .tag').addClass('active');
   $('.formula-list:nth-child(1) .formula-list-wrapper .formula-item').slideDown();
   $('.formula-list .formula-list-wrapper .tag').on('click', function() {
       if($(this).hasClass('active')) {
         $(this).siblings('.formula-list .formula-list-wrapper .formula-item').slideUp();
         $(this).removeClass('active');
       }
       else {
         $('.formula-list .formula-list-wrapper .formula-item').slideUp();
         $('.formula-list .formula-list-wrapper .tag').removeClass('active');
         $(this).siblings('.formula-list .formula-list-wrapper .formula-item').slideToggle();
         $(this).toggleClass('active');
       }
   });     
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["science-process"] && !window.DesignMode) return;
  try {
    

  $(document).ready(function() {
   $('.process-list:nth-child(1) .process-content h4').addClass('active');
   $('.process-list:nth-child(1) .process-content .process-description').slideDown();
   $('.process-list .process-content h4').on('click', function() {
       if($(this).hasClass('active')) {
         $(this).siblings('.process-list .process-content .process-description').slideUp();
         $(this).removeClass('active');
       }
       else {
         $('.process-list .process-content .process-description').slideUp();
         $('.process-list .process-content h4').removeClass('active');
         $(this).siblings('.process-list .process-content .process-description').slideToggle();
         $(this).toggleClass('active');
       }
   });     
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seedboost-faq"] && !window.DesignMode) return;
  try {
    

if($(window).width() >= 1026){
$('.faq-box').hide();
$('.faq-box:first').show();
$('.faq-heading h5:first').addClass('tab-active');

$('.faq-heading h5 a').on('click', function(event){
  event.preventDefault();
  $('.faq-heading h5').removeClass('tab-active');
  $(this).parent().addClass('tab-active');
  $('.faq-box').hide();
  $($(this).attr('href')).show();
});
}

if($(window).width() <= 576){  
$(function () {
  $(".ans").css("display", "none");
  // $(".qus:first-of-type").addClass("open");
  $(".qus").click(function () {
    $(".open").not(this).removeClass("open").next().slideUp(300);
    $(this).toggleClass("open").next().slideToggle(300);
  });
});
} 
else{
  $(function () {
  $(".ans:not(:first-of-type)").css("display", "none");
  $(".qus:first-of-type").addClass("open");
  $(".qus").click(function () {
    $(".open").not(this).removeClass("open").next().slideUp(300);
    $(this).toggleClass("open").next().slideToggle(300);
  });
});
}
if($(window).width() <= 1024){ 
window.onload=function(){
$slideshow = $(".faq-slider").slick({
    autoplay:false,
    autoplaySpeed: 5000,
    infinite: false,
    slidesToShow:1,
    slidesToScroll:1,
    arrows: false,
    dots: true,
    prevArrow:'<button class="PrevArrow">&#10229;</button>',
    nextArrow:'<button class="NextArrow">Show More</button>',
    asNavFor: '.faq-heading'
  });

  $(".faq-heading").slick({
    autoplay:false,
    autoplaySpeed: 3000,
    infinite: false,
    slidesToShow:1,
    slidesToScroll:1,
    arrows: false,
    dots: false,
    focusOnSelect: true,
    variableWidth: true,
    asNavFor: ".faq-slider", 
    responsive: [
    {
      breakpoint: 577,
      settings: {
        autoplay: false, 
        slidesToShow: 1,
        slidesToScroll: 1
      },
      breakpoint: 1025,
      settings: {
        slidesToShow: 1, 
        slidesToScroll: 1 
      }
    }
  ]
});


};
};




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seedboost-features"] && !window.DesignMode) return;
  try {
    

$(document).ready(function() {
$('.feature-accordion .item:nth-child(1) h5').addClass('active');
$('.feature-accordion .item:nth-child(1) p').slideDown();
$('.feature-accordion .item h5').on('click', function() {
    if($(this).hasClass('active')) {
      $(this).siblings('.feature-accordion .item p').slideUp();
      $(this).removeClass('active');
    }
    else {
      $('.feature-accordion .item p').slideUp();
      $('.feature-accordion .item h5').removeClass('active');
      $(this).siblings('.feature-accordion .item p').slideToggle();
      $(this).toggleClass('active');
    }
});     
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seedboost-ingredients"] && !window.DesignMode) return;
  try {
    

jQuery(document).ready(function(){

  var $this = $('.ingr-box.load-more');
  if ($this.find('.ingr-item').length > 2) {
      $('.ingr-box.load-more').append('<div class="moreless-btn"><a href="javascript:;" class="showMore"></a></div>');
  }
  $('.ingr-box.load-more .ingr-item').slice(0,8).addClass('shown');
  $('.ingr-box.load-more .ingr-item').not('.shown').hide();
  $('.ingr-box.load-more .showMore').on('click',function(){
      $('.ingr-box.load-more .ingr-item').not('.shown').toggle(0);
      $(this).toggleClass('showLess');
  });
  
  $(".tab-slider").slick({
    autoplay:false,
    infinite:true,
    slidesToShow:1,
    slidesToScroll:1,
    dots:true,
    arrows:false,
  });

  $(".mob-slider").slick({
    autoplay:false,
    infinite:true,
    slidesToShow:1,
    slidesToScroll:1,
    dots:true, 
    arrows:false,
  });

});  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seedboost-reviews"] && !window.DesignMode) return;
  try {
    

$(document).ready(function(){
  
  $(".seed-slider").slick({
    autoplay:true,
    autoplaySpeed: 5000,
    infinite: true,
    slidesToShow:3,
    slidesToScroll:1,
    arrows: true,
    dots: false,
    prevArrow:'<button class="PrevArrow">&#10229;</button>',
    nextArrow:'<button class="NextArrow">Show More</button>',
    responsive: [
    {
      breakpoint: 481,
      settings: {
        autoplay: false, 
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true
      }
    },
    {
      breakpoint: 1025, 
      settings: {
        autoplay: false, 
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: false,
        dots: true
      }
    }
  ]
  });
  
})

$(document).ready(function(){
  
  $(".accelerator-slider").slick({
    autoplay:true,
    autoplaySpeed: 5000,
    infinite: true,
    slidesToShow:3,
    slidesToScroll:1,
    arrows: false,
    dots: true,
    prevArrow:'<button class="PrevArrow">&#10229;</button>',
    nextArrow:'<button class="NextArrow">Show More</button>',
    responsive: [
    {
      breakpoint: 481,
      settings: {
        autoplay: false, 
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true
      }
    },
    {
      breakpoint: 1025, 
      settings: {
        autoplay: false, 
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: false,
        dots: true
      }
    }
  ]
  });
  
})


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seedcheck-features"] && !window.DesignMode) return;
  try {
    

$(document).ready(function() {
$('.feature-accordion .item:nth-child(1) h5').addClass('active');
$('.feature-accordion .item:nth-child(1) p').slideDown();
$('.feature-accordion .item h5').on('click', function() {
    if($(this).hasClass('active')) {
      $(this).siblings('.feature-accordion .item p').slideUp();
      $(this).removeClass('active');
    }
    else {
      $('.feature-accordion .item p').slideUp();
      $('.feature-accordion .item h5').removeClass('active');
      $(this).siblings('.feature-accordion .item p').slideToggle();
      $(this).toggleClass('active');
    }
});     
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["welcome-step-2"] && !window.DesignMode) return;
  try {
    
$slideshow = $(".product-slider-image").slick({
    autoplay:false,
    autoplaySpeed: 5000,
    infinite: false,
    slidesToShow:1,
    slidesToScroll:1,
    arrows: true,  
    fade: true,
    speed: 300,
    cssEase: 'linear', 
    dots: false,
    prevArrow:'<button class="Slider-arrow PrevArrow">&#10229;</button>',
    nextArrow:'<button class="Slider-arrow NextArrow">&#10230;</button>',
    asNavFor: '.product-slider-thumb',
    responsive: [
    {
      breakpoint: 1025, 
      settings: {
        dots: true,
        arrows: false  
      }
    }
  ]
  });

  $(".product-slider-thumb").slick({
    autoplay:false,
    infinite: false,
    slidesToShow:1,
    slidesToScroll:1,
    fade: true,
    speed: 250,
    cssEase: 'linear',
    arrows: false, 
    focusOnSelect: true,
    variableWidth: true, 
    dots: false, 
    asNavFor: ".product-slider-image"
});

  } catch(e) { console.error(e); }
})();
})();
